var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hubs.length > 1)?_c('div',{staticClass:"row",attrs:{"id":"hub-list"}},_vm._l((_vm.hubs),function(hub){return _c('service-hub-table',{key:hub.id,attrs:{"hub":hub},on:{"reloadList":_vm.reloadList}})})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffa4108a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/services/ServiceHubContainer.vue
// module id = JrIG
// module chunks = 1